import moment from 'moment-timezone';
import { takeLatest, put, call, select, delay } from 'redux-saga/effects';
import { axiosInstance } from '../../utils';

import {
  HOTEL_REVIEW_PROCESS_REQUEST,
  HOTEL_REVIEW_PROCESS_SUCCESS,
  HOTEL_REVIEW_PROCESS_FAILURE,
  CHANGE_CHECKIN_DATE_REQUEST,
  CHANGE_CHECKIN_DATE_SUCCESS,
  CHANGE_CHECKIN_DATE_FAILURE,
  CANCEL_TICKET_REQUEST,
  CANCEL_TICKET_SUCCESS,
  CANCEL_TICKET_FAILURE,
  MODAL_CLOSE,
  CHANGE_BOOKING_STATUS,
  CHANGING_CHECKING_DATE_SUCCESS,
} from "../types";

function* hotelReviewSaga({ payload }) {
  const survey = payload;
  const bookingId = yield select(state => state.bookingManagement.hotel.bookingId);
  const { step, stars, amenities, food, parking, spa, additional } = survey;

  try {
    yield call(axiosInstance.post, `bookings/survey/${bookingId}`, {
      survey: {
        BookingId: bookingId,
        Rating: stars.amount,
        RateCommend: stars.textReview,
        UsePool: amenities.includes('pool'),
        UseGym: amenities.includes('gym'),
        UseSpa: amenities.includes('spa'),
        UseBusinessCenter: amenities.includes('business'),
        IsBuyFoodAndDrink: food.bought === 'yes',
        FoodAndDrinkPrice: food.amount,
        IsPayForParking: parking.bought === 'yes',
        ParkingPrice: parking.amount,
        IsBuySpaService: spa.bought === 'yes',
        SpaServicePrice: spa.amount,
        IsBuyAdditionalService: additional.bought === 'yes',
        AdditionalServicePrice: additional.amount,
        IsFinish: true,
        LastStep: step,
      }
    });
    yield put({ type: HOTEL_REVIEW_PROCESS_SUCCESS });
  } catch (error) {
    yield put({ type: HOTEL_REVIEW_PROCESS_FAILURE, payload: 'Something went wrong' });
  }
}

function* changeCheckinDateSaga({ payload }) {
  const newDate = payload;
  const bookingId = yield select(state => state.bookingManagement.hotel.bookingId);
  const bookingManagementFormat = moment(payload).format('YYYY-MM-DD 00:00');

  try {
    const { data } = yield call(axiosInstance.post, 'bookings/checkin', { bookingId, newDate });
    yield put({ type: CHANGE_CHECKIN_DATE_SUCCESS,  payload: bookingManagementFormat});
    yield put({ type: CHANGING_CHECKING_DATE_SUCCESS, payload: data });

    yield delay(1000);
  } catch (error) {
    const message =  error.error  || 'Something went wrong';
    yield put({ type: CHANGE_CHECKIN_DATE_FAILURE, payload: message })
  }
}

function* cancelTicketSaga() {
  const bookingId = yield select(state => state.bookingManagement.hotel.bookingId);

  try {
    yield call(axiosInstance.post, `bookings/cancel/${bookingId}`);
    yield put({ type: CHANGE_BOOKING_STATUS, payload: 3 });
    yield put({ type: CANCEL_TICKET_SUCCESS });
    yield put({ type: MODAL_CLOSE });
  } catch (error) {
    yield put({ type: CANCEL_TICKET_FAILURE, payload: 'Something went wrong' })
  }
}

export default function* saga() {
  yield takeLatest(HOTEL_REVIEW_PROCESS_REQUEST, hotelReviewSaga);
  yield takeLatest(CHANGE_CHECKIN_DATE_REQUEST, changeCheckinDateSaga);
  yield takeLatest(CANCEL_TICKET_REQUEST, cancelTicketSaga);
}
